module.exports = __webpack_public_path__ + "img/yishi16.82357d45.jpg";